/* eslint no-nested-ternary: 0 */
import React, { Component, createRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import Auth from '@aws-amplify/auth';
import {
  Button,
  Checkbox,
  Container,
  Dimmer,
  Divider,
  Form,
  Grid,
  Header,
  Loader,
  Segment,
  Icon,
} from 'semantic-ui-react';
import i18n from 'i18next';
import _ from 'lodash';
import qs from 'qs';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import clone from 'clone';
import { withTranslation } from 'react-i18next';
import { required, stringLength, email, identity as ValidateIdentity, phoneNumber, numericRange, matchRegex } from '@mhub/web-validations';
import InsufficientCreditCheckModal from '../modals/InsufficientCreditCheck';
import { flashSuccessMessage, flashErrorMessage, flashMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { fetchAddressSettings } from '../../actions/addressSettings';
import { fetchCustomOptions } from '../../actions/customOptions';
import { getCountryName } from '../../utils/countries';
import { displayMoment } from '../../utils/displayTime';
import config from '../../../config';
import TinFieldInput from '../../components/AppForm/TinFieldInput';
import AppForm from '../../components/AppForm';
import NavBar from '../../components/NavBar';
import EditableBox from '../../components/EditableBox';
import Phone from '../../components/Phone';
import PhoneInput from '../../components/AppForm/PhoneInput';
import Identity from '../../components/Identity';
import CreditCheckScores from '../../components/CreditCheckScores';
import CreditCheckSplash from '../../components/CreditCheckSplash';
import LPPSAChecker from '../../components/LPPSAChecker';
import SearchBranch from '../../components/SearchBranch';
import CustomerBookings from '../../components/CustomerBookings';
import MarkdownText from '../../components/MarkdownText';
import LoanAmount from '../../components/LoanAmount';
import InputBirthdate from '../../components/InputBirthdate';
import CurrencySymbol from '../../components/CurrencySymbol';
import INTL_CALL_CODES from '../../constants/intlCallCodes';
import STATES from '../../constants/states';
import { SELECT_COUNTRIES, SELECT_NATIONALITY } from '../../constants/countries';
import { RACE } from '../../constants/race';
import { BUMI } from '../../constants/bumi';
import { GENDER } from '../../constants/gender';
import { MARITAL_STATUS } from '../../constants/maritalStatus';
import CUSTOMER_TITLES from '../../constants/customerTitles';
import { REGEX_TIN_VALID, REGEX_NPWP_ID } from '../../constants/regex';
import { getPhoneValidRegex } from '../../utils/validations/phone';
import { getIdentityTypeOpts, getSubmitIdentityTypeID } from '../../utils/identityTypes';
import { vnFullNameValidations, vnIdentityValidation, vnPreferredNameValidations } from '../../utils/vietnam';
import { isForeignCompany } from '../../utils/companies';
import INTL_FLAG_CODES from '../../constants/intlFlagCodes';
import IDENTITY_TYPE_OPTS, { IDENTITY_TYPE_BRN } from '../../constants/defaultIdentityTypeOpts';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { translateModels } from '../../utils/translation';
import { FOREIGN_BUYER_GENERIC_TIN, GENERIC_TIN_UNMATCHED_ERROR_MSG, GENERIC_TIN_VALUES, getAutoFillTin, getGenericTinByIdTypeAndTinNo, GOVERNMENT_GENERIC_TIN, isForeignIdType, isGenericTinFound } from '../../constants/tin';

const isPRS = config.get('prs');
const styles = {
  divider: { margin: '0.5em 0' },
};

class Overview extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isDeveloperStaff: PropTypes.bool,
      isExternalAgentLeader: PropTypes.bool,
      isExternalAgent: PropTypes.bool,
      isExternalAgencyAdmin: PropTypes.bool,
      creditCheckAccess: PropTypes.bool,
      companyBranch: PropTypes.shape({
        service_company_branch_id: PropTypes.string,
      }),
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    addressSettings: PropTypes.shape({
      data: PropTypes.array,
    }),
    identityPresets: PropTypes.shape({
      data: PropTypes.array,
    }),
    customOptions: PropTypes.shape({
      data: PropTypes.array,
    }),
    onCheck: PropTypes.func,
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    addressSettings: state.addressSettings,
    identityPresets: state.identityPresets,
    phoneValidationPresets: state.phoneValidationPresets,
    customOptions: state.customOptions,
  })
  static defaultCustomerData = {
    id: '',
    customerID: '',
    customerDetailID: '',
    identityTypeID: '',
    identity: '',
    internalRemark: '',
    lppsaResult: {
      name: '',
      key: '',
    },
    lppsaResultID: '',
    lppsaResultStatusID: '',
  }
  static defaultCustomerDetailData = {
    title: '',
    name: '',
    preferredName: '',
    email: '',
    mobilePrefix: '',
    mobile: '',
    phonePrefix: '',
    phone: '',
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    address5: '',
    address6: '',
    address7: '',
    address8: '',
    address9: '',
    address10: '',
    country: '',
    jobTitle: '',
    monthlyIncome: '',
    nationality: '',
    birthdate: '',
    gender: '',
    race: '',
    bumi: '',
    maritalStatus: '',
    occupation: '',
    emergencyContactName: '',
    emergencyContactRelation: '',
    emergencyContactMobilePrefix: '60',
    emergencyContactMobile: '',
    emergencyContactEmail: '',
    emergencyContactIdentity: '',
  }
  static defaultValues = {
    identityTypeID: null,
    identity: '',
    identityPresetID: '',
    identityPresetLabel: '',
    identityPresetRegex: '',
    taxIdentificationNo: '',
    taxTinValidationStatus: 'failed',
    title: '',
    name: '',
    preferredName: '',
    email: '',
    mobilePrefix: '60',
    mobile: '',
    phonePrefix: '60',
    phone: '',
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    address5: '',
    address6: '',
    address7: '',
    address8: '',
    address9: '',
    address10: '',
    country: '',
    jobTitle: '',
    monthlyIncome: '',
    nationality: '',
    birthdate: '',
    gender: '',
    race: '',
    raceOther: '',
    bumi: '',
    maritalStatus: '',
    occupation: '',
    emergencyContactName: '',
    emergencyContactRelation: '',
    emergencyContactMobilePrefix: '60',
    emergencyContactMobile: '',
    emergencyContactEmail: '',
    emergencyContactIdentity: '',
    isForeignCompany: false,
    maOwnerCompanyBranchID: 0,
    maOwnerCompanyBranchShortName: '',
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = Object.assign({}, Overview.defaultCustomerData, props.data || {});

    let hideTitle = false;
    const customOptions = props.customOptions.data;
    if (customOptions.length > 0) {
      const hideTitleOpt = customOptions.find(o => o.name === 'hide_purchaser_title');
      if (hideTitleOpt) {
        hideTitle = hideTitleOpt.value === 'true';
      }
    }
    if (hideTitle) {
      Overview.defaultCustomerDetailData.title = 'Not Applicable';
      Overview.defaultValues.title = 'Not Applicable';
    }

    let defaultCountryPhoneCode = '60';
    let defaultCountryAddressCode = 'my';
    const auth = props.auth;
    if (auth && isForeignCompany(auth.company)) {
      const idx = INTL_FLAG_CODES.findIndex(f => f.countryCode === auth.company.countryCode);
      if (idx !== -1) {
        defaultCountryPhoneCode = INTL_FLAG_CODES[idx].value;
        defaultCountryAddressCode = INTL_FLAG_CODES[idx].countryCode;
      }
    }
    if (!data.customerDetailID) {
      data.customerDetail = Object.assign({}, Overview.defaultCustomerDetailData);
      data.customerDetail.emergencyContactMobilePrefix = defaultCountryPhoneCode;
      data.customerDetail.country = defaultCountryAddressCode;
    }
    const dataEditingCustomer = {
      identityTypeID: data.identityTypeID,
      identity: data.identity,
      identityPresetID: data.identityPresetID,
      identityPresetLabel: data.identityPresetLabel,
      identityPresetRegex: data.identityPresetRegex,
      taxIdentificationNo: data.taxIdentificationNo,
      taxTinValidationStatus: data.taxTinValidationStatus,
      title: hideTitle ? 'Not Applicable' : data.customerDetail.title,
      name: data.customerDetail.name,
      preferredName: data.customerDetail.preferredName,
      email: data.customerDetail.email,
      mobilePrefix: data.customerDetail.mobilePrefix,
      mobile: data.customerDetail.mobile,
      phonePrefix: data.customerDetail.phonePrefix,
      phone: data.customerDetail.phone,
      address1: data.customerDetail.address1,
      address2: data.customerDetail.address2,
      address3: data.customerDetail.address3,
      address4: data.customerDetail.address4,
      address5: data.customerDetail.address5,
      address6: data.customerDetail.address6,
      address7: data.customerDetail.address7,
      address8: data.customerDetail.address8,
      address9: data.customerDetail.address9,
      address10: data.customerDetail.address10,
      country: data.customerDetail.country,
      jobTitle: data.customerDetail.jobTitle,
      monthlyIncome: data.customerDetail.monthlyIncome,
      nationality: data.customerDetail.nationality,
      birthdate: data.customerDetail.birthdate,
      gender: data.customerDetail.gender,
      race: data.customerDetail.race,
      bumi: data.customerDetail.bumi,
      maritalStatus: data.customerDetail.maritalStatus,
      occupation: data.customerDetail.occupation,
      internalRemark: data.internalRemark,
      maOwnerCompanyBranchShortName: data.maOwnerCompanyBranchShortName,
      maOwnerCompanyBranchID: data.maOwnerCompanyBranchID,
      emergencyContactName: data.customerDetail.emergencyContactName,
      emergencyContactRelation: data.customerDetail.emergencyContactRelation,
      emergencyContactMobilePrefix: data.customerDetail.emergencyContactMobilePrefix,
      emergencyContactMobile: data.customerDetail.emergencyContactMobile,
      emergencyContactEmail: data.customerDetail.emergencyContactEmail,
      emergencyContactIdentity: data.customerDetail.emergencyContactIdentity,
      isForeignCompany: data.isForeignCompany,
    };
    const isPresetRace = RACE.find(d => d.value === data.customerDetail.race);
    if (!isPresetRace && data.customerDetail.race !== '') {
      dataEditingCustomer.race = 'Others';
      dataEditingCustomer.raceOther = data.customerDetail.race;
    }
    Overview.defaultValues.mobilePrefix = defaultCountryPhoneCode;
    Overview.defaultValues.phonePrefix = defaultCountryPhoneCode;
    Overview.defaultValues.emergencyContactMobilePrefix = defaultCountryPhoneCode;
    Overview.defaultValues.country = defaultCountryAddressCode;
    const editingCustomer = Object.assign({}, Overview.defaultValues, dataEditingCustomer);

    const identityPresets = props.identityPresets.data;
    let identityTypeOpts = IDENTITY_TYPE_OPTS;
    const phoneValidationPresets = props.phoneValidationPresets.data;

    if (props.auth && isForeignCompany(props.auth.company)) {
      // remove NRIC or Military/Police identities if editing customer's identity is not these types
      let defaultFilters = [1, 3];
      if (editingCustomer && (editingCustomer.identityTypeID === 1 || editingCustomer.identityTypeID === 3)) {
        defaultFilters = defaultFilters.filter(f => f !== editingCustomer.identityTypeID);
      }
      identityTypeOpts = identityTypeOpts.filter(o => !defaultFilters.includes(o.value));
      // check for new identity presets
      if (identityPresets && identityPresets.length > 0) {
        const newPresetOptions = identityPresets.map(i => ({
          text: i.label,
          value: i.id === editingCustomer.identityPresetID ? 6 : i.id,
          'data-regex': i.regex,
        }));
        // Remove duplicates by checking if value already exists in identityTypeOpts
        const uniquePresetOptions = newPresetOptions.filter(newOpt =>
          !identityTypeOpts.some(existingOpt => existingOpt.value === newOpt.value),
        );
        identityTypeOpts = [...identityTypeOpts, ...uniquePresetOptions];
      }
      // check if existing customer's identity is deleted identity preset
      if (editingCustomer && editingCustomer.identityTypeID > 4) {
        const idx = identityPresets.findIndex(i => i.id === editingCustomer.identityPresetID);
        if (idx === -1) {
          // Check if this identity type doesn't already exist before adding
          const existingIdentityType = identityTypeOpts.find(opt => opt.value === editingCustomer.identityTypeID);
          if (!existingIdentityType) {
            identityTypeOpts.unshift({ text: editingCustomer.identityPresetLabel ? editingCustomer.identityPresetLabel : 'ID Number', value: editingCustomer.identityTypeID, 'data-regex': editingCustomer.identityPresetRegex ? editingCustomer.identityPresetRegex : '' });
          }
        }
      }
    }

    // flag to enable/disable tin searched using the lhdn api
    const tinFound = false;

    return {
      data,
      oriData: clone(data),
      loading,
      editingCustomer,
      identityTypeOpts,
      phoneValidationPresets,
      hideTitle,
      tinFound,
    };
  }
  constructor(props) {
    super(props);
    const state = Overview.getPropsToState(props);
    this.state = {
      ...state,
      companyApp: [],
      creditSubscription: {
        amount: 0,
      },
      errMessages: [],
      tinMessage: null,
      edit: false,
      hasChanges: false,
      openInsufficientCreditModal: false,
    };
    this.validation = {
      preferredName: createRef(),
      mobile: createRef(),
      phone: createRef(),
      identity: createRef(),
      taxIdentificationNo: createRef(),
      title: createRef(),
      name: createRef(),
      email: createRef(),
      mobilePrefix: createRef(),
      monthlyIncome: createRef(),
      country: createRef(),
      raceOther: createRef(),
      emergencyContactMobilePrefix: createRef(),
      emergencyContactMobile: createRef(),
      emergencyContactEmail: createRef(),
    };

    // add validateRef for all enabled address settings
    const enabledAddressSettings = props.addressSettings.data.filter(as => as.enabled);
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach((as) => {
        const key = _.camelCase(as.columnName);
        this.validation[key] = createRef();
      });
    }
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchAddressSettings());
    store.dispatch(fetchCustomOptions());
  }
  componentWillReceiveProps(nextProps) {
    const state = Overview.getPropsToState(nextProps);
    let tinFoundOnInitialize = false;
    const identityPresets = nextProps.identityPresets.data || [];
    state.identityTypeOpts = getIdentityTypeOpts(nextProps.auth, identityPresets);
    if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
      state.editingCustomer = this.state.editingCustomer;
    }
    if (state && state.data && state.data.customerCreditReportID && this.props.auth &&
      (this.props.auth.isBranchLeader ||
        this.props.auth.isDeveloperStaff ||
        this.props.auth.isExternalAgentLeader ||
        this.props.auth.isExternalAgent ||
        this.props.auth.isExternalAgencyAdmin)
    ) {
      this.fetchCompanyApp();
    }
    if (state && state.editingCustomer && state.editingCustomer.taxIdentificationNo && state.editingCustomer.taxTinValidationStatus === 'success') {
      tinFoundOnInitialize = true;
    }
    this.setState({ ...state, tinFound: tinFoundOnInitialize });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.editingCustomer !== this.state.editingCustomer) {
      this.updateTinFieldState();
    }
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  getCreditsSubscriptionFragment = () => `
  id
  company_id
  company_branch_id
  amount
  currency_code
  created_at
  created_by
  updated_at
  updated_by
`
  getIdentityTypeText(identityID) {
    const { identityTypeOpts } = this.state;
    const { auth } = this.props;
    const isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';

    if (identityID === 1 && isVietnam) {
      return 'CCCD';
    }
    if (identityTypeOpts && identityTypeOpts.length > 0) {
      const idx = identityTypeOpts.findIndex(i => i.value === identityID);
      if (idx !== -1) {
        return identityTypeOpts[idx].text;
      }
    }
    return '';
  }
  getSelectedBranchValue = () => {
    const { editingCustomer } = this.state;
    const selectedBranchValue = {
      key: editingCustomer.maOwnerCompanyBranchID.toString() || 0,
      title: editingCustomer.maOwnerCompanyBranchShortName || '',
    };
    return selectedBranchValue;
  }
  setLoading = (loading = false, loadingType) => new Promise((res) => {
    if (loadingType === 'validatingTIN') {
      this.setState({ validatingTin: loading }, res);
    } else {
      this.setState({ loading }, res);
    }
  })
  updateTinFieldState = () => {
    const { editingCustomer } = this.state;
    let tinError = true;
    if (editingCustomer && editingCustomer.taxTinValidationStatus === 'success') {
      tinError = false;
    }
    if (this.state.tinError !== tinError) {
      this.setState({ tinError });
    }
  }
  hasAccess(check = false) {
    if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
      return true;
    }
    return check;
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        this.handleOnCheck(true);
      });
    }
  }
  handleCheckAvailableCredits = () => {
    this.setLoading(true);
    const { companyBranch } = this.props.auth;
    let availableCredit = 0;

    const { store } = this.context;
    const id = companyBranch && companyBranch.service_company_branch_id;
    Auth.currentSession()
    .then((result) => {
      let creditsSubscriptionToken = (result).getIdToken().getJwtToken();
      if (config.get('server') === 'development') {
        creditsSubscriptionToken = config.get('subsAuth');
      }
      fetch(config.get('subscriptionApiEndpoint'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: creditsSubscriptionToken,
        },
        body: JSON.stringify({
          query: `
            query {
              getSubscription(
                id: "${id}",
              ) { ${this.getCreditsSubscriptionFragment()} }
            }
          `,
        }),
      })
      .then(async (res) => {
        if (res.ok) {
          const { data } = await res.json();
          if (data && data.getSubscription) {
            availableCredit = data.getSubscription.amount;
            this.setState({
              creditSubscription: { ...data.getSubscription },
            });

            if (availableCredit < 10) {
              this.setState({ openInsufficientCreditModal: true });
            } else {
              window.location.href = `/customers/${this.state.data.id}/credit_check/#new`;
            }
          }
        } else {
          const message = 'Failed to retrieve subscription data';
          store.dispatch(flashErrorMessage(message));
        }
      });
    })
    .catch(err => store.dispatch(flashErrorMessage(err)));
    this.setLoading(false);
  }
  handleCloseInsufficientCreditModal = (e) => {
    e.preventDefault();
    this.setState({ openInsufficientCreditModal: false });
  }
  handleResetCheck() {
    if (this.state.hasChanges) {
      this.setState({ hasChanges: false }, () => {
        this.handleOnCheck(false);
      });
    }
  }
  handleChange = (event, value) => {
    const { editingCustomer, data } = this.state;
    const { auth } = this.props;
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    // Change real time state of display title and name
    if (value.name === 'title' || value.name === 'name') {
      data.customerDetail[value.name] = value.value;
    }
    editingCustomer[value.name] = value.value;
    if (isMalaysia) {
      if (value.name === 'identityTypeID') {
        editingCustomer.isForeignCompany = false;
        editingCustomer.taxIdentificationNo = getAutoFillTin(editingCustomer.identityTypeID, editingCustomer.isForeignCompany);
      }
    }
    this.setState({ editingCustomer, data, tinMessage: null, tinError: false, tinFound: false }, () => {
      // Validate identity again on identityTypeID change
      if (value.name === 'identityTypeID') {
        AppForm.validate(this.validation, this.state.editingCustomer)
        .then((validations) => {
          this.setState({
            errMessages: validations.filter(v => !v.isValid),
          });
        });

        // Validate pref name | contact persion
        if (this.validation.preferredName && this.validation.preferredName.current && editingCustomer.preferredName !== '') {
          this.validation.preferredName.current.validate(editingCustomer.preferredName);
        }
        // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
        if (this.validation.name && this.validation.name.current && editingCustomer.name !== '') {
          this.validation.name.current.validate(editingCustomer.name);
        }
        if (editingCustomer.taxIdentificationNo !== '') {
          this.handleTinInput({ target: { value: editingCustomer.taxIdentificationNo } });
        }
      }
      if (value.name === 'identity' && editingCustomer.taxIdentificationNo !== '') {
        this.handleTinInput({ target: { value: editingCustomer.taxIdentificationNo } });
      }
      if (value.name === 'mobilePrefix') {
        this.validation.mobile.current.validate(editingCustomer.mobile);
      }
      if (value.name === 'phonePrefix') {
        this.validation.phone.current.validate(editingCustomer.phone);
      }
      this.handleCheckChanges();
    });
  }
  handleUpdateCustomer = () => {
    this.putCustomer();
  }
  handleEditCustomer = () => {
    this.setState({ edit: true });
  }
  handleResetCustomer = () => {
    const { oriData } = this.state;
    this.setState({
      edit: false,
      data: clone(oriData),
    }, () => {
      this.handleResetCheck();
    });
  }
  handleOpenHTML = (event) => {
    event.preventDefault();
    const { data } = this.state;
    if (data.customerCreditReport && data.customerCreditReport.mCtosHTMLRequestID !== '') {
      const url = `${config.get('bookApiURL')}/customers/${data.id}/credit_reports/${data.customerCreditReport.id}/response/${data.customerCreditReport.mCtosHTMLRequestID}/`;
      window.open(url, `credit-report-${data.customerCreditReport.mCtosHTMLRequestID}`, '');
    }
  }
  handleBranchClear = () => {
    const { editingCustomer } = this.state;
    editingCustomer.maOwnerCompanyBranchShortName = '';
    editingCustomer.maOwnerCompanyBranchID = 0;
    this.setState({ editingCustomer }, () => {
      this.handleCheckChanges();
    });
  }
  handleBranchSelect = (value) => {
    const { editingCustomer } = this.state;
    editingCustomer.maOwnerCompanyBranchShortName = value.title;
    editingCustomer.maOwnerCompanyBranchID = value.key;
    this.setState({ editingCustomer }, () => {
      this.handleCheckChanges();
    });
  }
  handleOnChangeLPPSA = (data) => {
    this.setState({ data }, () => {
      this.putCustomer();
    });
  }
  async fetchCompanyApp() {
    const { store } = this.context;
    await this.setLoading(true);
    let res;
    try {
      res = await store.dispatch(fetchM('/company/company_app/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const companyApp = await res.json();
      if (companyApp !== null) {
        this.setState({ companyApp });
      }
    }
    await this.setLoading(false);
  }
  async putCustomer() {
    const { store } = this.context;
    const { auth, t } = this.props;
    const { data, editingCustomer, identityTypeOpts } = this.state;
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    
    try {
      const validations = await AppForm.validate(this.validation, editingCustomer);
      const errMessages = validations.filter(v => !v.isValid);
      await this.setComponentState({
        errMessages,
      });
      if (errMessages.length > 0) {
        await this.setComponentState({ edit: true });
        store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errMessages.map(l => l.message) }));
        return;
      }
    } catch (validationErr) {
      Bugsnag.notifyException(validationErr);
      await this.setComponentState({ edit: true });
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), message: t('Form validation failed. Please check your input and try again.', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (editingCustomer.maOwnerCompanyBranchShortName === '' || editingCustomer.maOwnerCompanyBranchID === 0 || editingCustomer.maOwnerCompanyBranchID === '' || !editingCustomer.maOwnerCompanyBranchID) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), message: t('Customer\'s Business Unit Owner is required', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (editingCustomer.identityTypeID && typeof (editingCustomer.identityTypeID) === 'string') {
      let idx = -1;
      if (identityTypeOpts && identityTypeOpts.length > 0) {
        idx = identityTypeOpts.findIndex(i => i.value === editingCustomer.identityTypeID);
      }
      if (idx !== -1) {
        editingCustomer.identityTypeID = 6;
        editingCustomer.identityPresetID = identityTypeOpts[idx].value;
        editingCustomer.identityPresetLabel = identityTypeOpts[idx].text;
        editingCustomer.identityPresetRegex = identityTypeOpts[idx]['data-regex'];
      }
    }
    // 6 is only kept with a known preset, so a customer saved as 6 without one has to pick
    // a real type (MS-6661)
    const identityTypeID = getSubmitIdentityTypeID(
      editingCustomer.identityTypeID,
      editingCustomer.identityPresetID,
      this.props.identityPresets.data,
    );
    if (!identityTypeID) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), message: t('Please select Identity Type') }));
      return;
    }
    editingCustomer.taxTinValidationStatus = this.state.tinError === false ? 'success' : 'failed';
    if (!isIndonesia && editingCustomer.taxTinValidationStatus !== 'success' && editingCustomer.identityTypeID === IDENTITY_TYPE_BRN && !editingCustomer.isForeignCompany) {
      store.dispatch(flashMessage({
        header: t('Invalid TIN', { ns: TRANSLATION_FILES.translation }),
        message: t('Tax Identification Number is invalid', { ns: TRANSLATION_FILES.translation }),
        icon: 'warning sign',
        type: 'error',
        autoHideDuration: 5000,
      }));
      return;
    }
    await this.setLoading(true);
    const customerDetail = {
      title: this.state.hideTitle ? 'Not Applicable' : editingCustomer.title,
      name: editingCustomer.name,
      preferredName: editingCustomer.preferredName,
      email: editingCustomer.email,
      mobilePrefix: editingCustomer.mobilePrefix,
      mobile: editingCustomer.mobile,
      phonePrefix: editingCustomer.phonePrefix,
      phone: editingCustomer.phone,
      address1: editingCustomer.address1,
      address2: editingCustomer.address2,
      address3: editingCustomer.address3,
      address4: editingCustomer.address4,
      address5: editingCustomer.address5,
      address6: editingCustomer.address6,
      address7: editingCustomer.address7,
      address8: editingCustomer.address8,
      address9: editingCustomer.address9,
      address10: editingCustomer.address10,
      country: editingCustomer.country,
      jobTitle: editingCustomer.jobTitle,
      monthlyIncome: parseFloat(editingCustomer.monthlyIncome),
      nationality: editingCustomer.nationality,
      birthdate: editingCustomer.birthdate,
      gender: editingCustomer.gender,
      race: editingCustomer.race.toUpperCase() === 'Others'.toUpperCase() ? editingCustomer.raceOther : editingCustomer.race,
      bumi: editingCustomer.bumi,
      maritalStatus: editingCustomer.maritalStatus,
      occupation: editingCustomer.occupation,
      emergencyContactName: editingCustomer.emergencyContactName,
      emergencyContactRelation: editingCustomer.emergencyContactRelation,
      emergencyContactMobilePrefix: editingCustomer.emergencyContactMobilePrefix,
      emergencyContactMobile: editingCustomer.emergencyContactMobile,
      emergencyContactEmail: editingCustomer.emergencyContactEmail,
      emergencyContactIdentity: editingCustomer.emergencyContactIdentity,
    };
    const postCustomer = {
      customerDetail,
      customerDetailID: data.customerDetailID,
      id: data.id,
      identityTypeID,
      identity: editingCustomer.identity,
      identityPresetID: editingCustomer.identityPresetID,
      identityPresetLabel: editingCustomer.identityPresetLabel,
      identityPresetRegex: editingCustomer.identityPresetRegex,
      taxIdentificationNo: editingCustomer.taxIdentificationNo,
      taxTinValidationStatus: editingCustomer.taxTinValidationStatus,
      maOwnerCompanyBranchShortName: editingCustomer.maOwnerCompanyBranchShortName,
      maOwnerCompanyBranchID: editingCustomer.maOwnerCompanyBranchID,
      internalRemark: editingCustomer.internalRemark,
      lppsaResultID: data.lppsaResultID,
      lppsaResultStatusID: data.lppsaResultStatusID,
      isForeignCompany: editingCustomer.isForeignCompany,
    };
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/customers/${data.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(postCustomer),
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    
    // Check if response is valid and has OK status
    if (!res || !res.ok) {
      await this.setLoading(false);
      try {
        const errorText = await res.text();
        store.dispatch(flashErrorMessage({ message: errorText || t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
      } catch (parseErr) {
        store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
      }
      return;
    }
    
    let respondData;
    try {
      respondData = await res.json();
    } catch (parseErr) {
      await this.setLoading(false);
      Bugsnag.notifyException(parseErr);
      store.dispatch(flashErrorMessage({ message: t('There was an error processing the response. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    
    await this.setComponentState({
      loading: false,
      edit: false,
    }, () => {
      this.handleResetCheck();
    });
    store.dispatch(push(`/customers/${data.id}/`));
    store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: t('Customer {{name}} has been successfully updated', { ns: TRANSLATION_FILES.translation, name: respondData.customerDetail.name }) }));
  }
  valueToText = (array, value) => {
    const element = array.find(a => a.value === value);
    if (element && element.text) {
      return element.text;
    }
    return '';
  }
  validateIdentityType = () => {
    const { auth } = this.props;
    const identityType = this.state.editingCustomer.identityTypeID;
    const isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';
    switch (identityType) {
      case 1:
        return isVietnam ? 'vn_cccd' : 'ic_number';
      case 2:
        return 'passport';
      case 3:
        return 'military_police';
      case 5:
        return 'id_number';
      default:
        return 'other';
    }
  }

  identityValidation = () => {
    const { editingCustomer, identityTypeOpts } = this.state;
    const { auth, t } = this.props;
    const isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';
    
    // If identityTypeID is not set, return a safe default validation that won't crash
    if (!editingCustomer.identityTypeID || editingCustomer.identityTypeID === '' || editingCustomer.identityTypeID === null) {
      return {
        countryCode: isVietnam ? 'VN' : 'MY',
        identityType: isVietnam ? 'vn_cccd' : 'ic_number',
      };
    }
    
    if (editingCustomer.identityTypeID === 6 || typeof (editingCustomer.identityTypeID) === 'string') {
      const idx = identityTypeOpts.findIndex(i => i.value === editingCustomer.identityTypeID);
      let regex = '';
      if (idx !== -1) {
        regex = identityTypeOpts[idx]['data-regex'];
      }
      return {
        validRegex: regex,
      };
    }
    // CPI-974: the shared CCCD rule and the CRM's wording, the same pair the booking form and
    // the Purchaser tab read. Non-null on exactly the case validateIdentityType() calls
    // 'vn_cccd' - a Vietnamese company and identity type 1 - so the return below is unchanged.
    const vn = vnIdentityValidation(auth, editingCustomer.identityTypeID, t);
    if (vn) {
      return vn;
    }
    
    // For identity types like passport (2), military police (3), etc. that may not have specific validation rules,
    // return a permissive regex validation instead of using validateIdentityType()
    const identityType = this.validateIdentityType();
    if (identityType === 'passport' || identityType === 'military_police' || identityType === 'other') {
      return {
        validRegex: '.*', // Accept any non-empty string for these types
      };
    }
    
    return {
      countryCode: isVietnam ? 'VN' : 'MY',
      identityType,
    };
  }
  handleTinInput = (e) => {
    const { editingCustomer, tinMessage } = this.state;
    const { auth } = this.props;
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      editingCustomer.taxIdentificationNo = e.target.value;
      this.setState({
        editingCustomer,
        taxIdentificationNo: e.target.value,
        tinError: null,
        tinMessage: null,
      }, () => {
        this.handleCheckChanges();
      });
      return;
    }

    const tinInput = e.target.value;
    const tinFound = e.target.tinFound;
    const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (tinInput === '') {
      editingCustomer.taxIdentificationNo = '';
      this.setState({ taxIdentificationNo: '', editingCustomer, tinFound, tinError: false, tinMessage: null });
      return;
    }

    if (isAlphanumeric) {
      editingCustomer.taxIdentificationNo = tinInput;
      this.setState({ taxIdentificationNo: tinInput, editingCustomer, tinFound, tinError: tinFound === false, tinMessage: tinFound ? null : tinMessage }, () => {
        this.handleCheckChanges();
      });

      if (tinFound) {
        return;
      }
      // 1~2 letter followed by numeric with length 9 - 11
      const matched = REGEX_TIN_VALID.test(tinInput);
      const genericTin = getGenericTinByIdTypeAndTinNo(editingCustomer.identityTypeID, tinInput, editingCustomer.isForeignCompany);
      this.setLoading(true, 'validatingTIN').then(() => {
        if (this.debounceTimeout) {
          clearTimeout(this.debounceTimeout);
        }

        this.debounceTimeout = setTimeout(() => {
          if (matched) {
            if (tinInput === GOVERNMENT_GENERIC_TIN) {
              const isForeign = !isForeignIdType(editingCustomer.identityTypeID, editingCustomer.identityTypeID === IDENTITY_TYPE_BRN && editingCustomer.isForeignCompany);
              this.setState({
                tinError: !isForeign,
                tinFound: !isForeign,
                tinMessage: !isForeign ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
              () => {
                this.setLoading(false, 'validatingTIN');
              });
            } else if (GENERIC_TIN_VALUES.includes(tinInput)) {
              this.setState({
                tinError: !isGenericTinFound(genericTin),
                tinFound: isGenericTinFound(genericTin),
                tinMessage: !isGenericTinFound(genericTin) ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
              () => {
                this.setLoading(false, 'validatingTIN');
              });
            } else {
              this.validateTIN(tinInput).finally(() => {
                this.setLoading(false, 'validatingTIN');
              });
            }
          } else {
            this.setState({ tinError: true }, () => {
              this.setLoading(false, 'validatingTIN');
            });
          }
        }, 3000);
      });
    }
  }
  async validateTIN(tinInput) {
    const { editingCustomer, data } = this.state;
    if (!tinInput || !editingCustomer.identityTypeID || !editingCustomer.identity) {
      return;
    }
    const idType = getIdentityTypeOpts().find(i => i.value === editingCustomer.identityTypeID).tin_code;
    const query = Object.assign({
      tin: tinInput,
      idType,
      idValue: editingCustomer.identity,
      customerID: data.id,
    });
    const { store } = this.context;
    try {
      const res = await store.dispatch(fetchM(`/tin/validate/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
          'X-Origin': this.state.origin,
        },
      }));

      if (res && res.ok) {
        this.setState({
          tinError: false,
          tinFound: true,
          tinMessage: null,
        });
      } else {
        const errorMessage = await res.text();
        this.setState({
          tinError: true,
          tinFound: false,
          tinMessage: errorMessage,
        });
        return;
      }
    } catch (err) {
      if (err.res) {
        const errorMessage = await err.res.text();
        this.setState({
          tinError: true,
          tinFound: false,
          tinMessage: errorMessage,
        });
      }
    }
  }
  render() {
    const { addressSettings, auth, t } = this.props;
    const { data, companyApp, editingCustomer, openInsufficientCreditModal } = this.state;
    const { store } = this.context;
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    const isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';
    // CPI-1319: Vietnam-only no-digits rule on Full Name ([] elsewhere and for a company name).
    const vnFullNameRules = vnFullNameValidations(auth, editingCustomer.identityTypeID, t);
    const isMalaysiaAddress = editingCustomer.country.toUpperCase() === 'MY';
    const enabledAddressSettings = addressSettings.data.filter(as => as.enabled);
    const mustValidTin = editingCustomer.identityTypeID === 4;

    let tinValidation = [];
    if (isIndonesia) {
      tinValidation = [
        {
          validate: matchRegex,
          option: { validRegex: REGEX_NPWP_ID },
        },
      ];
    } else if (isMalaysia) {
      tinValidation = [
        { validate: matchRegex,
          option: { validRegex: REGEX_TIN_VALID },
        },
      ];
    }
    return (
      <Container>
        <InsufficientCreditCheckModal
          open={openInsufficientCreditModal}
          onClose={e => this.handleCloseInsufficientCreditModal(e)}
        />
        <NavBar
          header={t('Overview')}
        />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Dimmer active={this.state.loading} inverted>
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Divider horizontal>{t('Customer Information')}</Divider>
              <EditableBox
                editable
                isEditing={this.state.edit}
                loading={this.state.loading}
                onEdit={this.handleEditCustomer}
                onClick={this.handleUpdateCustomer}
                onCancel={this.handleResetCustomer}
                content={({ isEditing, onConfirm }) => (
                  <Grid>
                    <Grid.Row>
                      <Dimmer active={this.state.isEditing} inverted />
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <Grid>
                          <Grid.Row stretched>
                            <Grid.Column width={16}>
                              <Header as="h2" textAlign="center">
                                {data.customerDetail.title === 'Not Applicable' ? '' : t(data.customerDetail.title, { ns: TRANSLATION_FILES.constants })} {data.customerDetail.name}
                                <Header.Subheader>
                                  <i>{displayMoment(data.createdAt, auth && auth.company && auth.company.countryCode).locale(i18n.language).format('MMMM Do YYYY, h:mm a')}</i>
                                </Header.Subheader>
                              </Header>
                            </Grid.Column>
                            <Grid.Column width={16}>
                              <Divider hidden className="tablet-hide" />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                        <Divider hidden className="large-hide small-hide" />
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <AppForm
                          error={this.state.errMessages.length > 0}
                          onSubmit={onConfirm}
                          ref={(ref) => { this.form = ref; }}
                        >
                          <Grid>
                            <Grid.Row>
                              <Grid.Column mobile={16} tablet={8} computer={8}>
                                {
                                isEditing &&
                                  <Grid>
                                    <Grid.Column textAlign="left" width={8}>
                                      <Form.Select
                                        fluid
                                        onChange={this.handleChange}
                                        placeholder={`${translateModels(t, 'identityTypeID', 'customer')}*`}
                                        name="identityTypeID"
                                        options={this.state.identityTypeOpts.map(i => ({ ...i, text: t(i.text, { ns: TRANSLATION_FILES.screens }) }))}
                                        selection
                                        selectOnBlur={false}
                                        value={editingCustomer.identityTypeID}
                                      />
                                      {
                                        isMalaysia && editingCustomer.identityTypeID === IDENTITY_TYPE_BRN && (
                                          <Form.Field>
                                            <div style={{ display: 'flex', justifyContent: 'start' }}>
                                              <Checkbox
                                                label={t('Foreign Company', { ns: TRANSLATION_FILES.screens })}
                                                onChange={(e, d) => {
                                                  const setStateTin = d.checked ? FOREIGN_BUYER_GENERIC_TIN : '';
                                                  this.setState(prevState => ({
                                                    editingCustomer: {
                                                      ...prevState.editingCustomer,
                                                      taxIdentificationNo: setStateTin,
                                                      isForeignCompany: d.checked,
                                                    },
                                                  }), () => {
                                                    this.handleTinInput({ target: { value: d.checked ? this.state.editingCustomer.taxIdentificationNo : '', tinFound: false } });
                                                  });
                                                }}
                                                checked={this.state.editingCustomer.isForeignCompany}
                                              />
                                            </div>
                                          </Form.Field>
                                        )
                                      }
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={8}>
                                      <AppForm.Input
                                        name="identity"
                                        disabled={this.state.editingCustomer.identityTypeID === ''}
                                        validation={[
                                          required,
                                          {
                                            validate: ValidateIdentity,
                                            option: this.identityValidation(),
                                          },
                                        ]}
                                        ref={this.validation.identity}
                                        onChange={this.handleChange}
                                        validateLabel={translateModels(t, 'identity', 'customer')}
                                        placeholder={`${translateModels(t, 'identity', 'customer')}*`}
                                        type="text"
                                        value={editingCustomer.identity}
                                      />
                                    </Grid.Column>
                                  </Grid>
                                }
                                {
                                isEditing &&
                                  <Divider style={styles.divider} />
                                }
                                {
                                  isEditing && !this.state.hideTitle ?
                                    <Grid>
                                      <Grid.Column textAlign="left" width={6}>
                                        <b>{translateModels(t, 'title', 'customer')}{isEditing && '*'}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={10}>
                                        <AppForm.Validate
                                          validation={[required]}
                                          ref={this.validation.title}
                                          onChange={this.handleChange}
                                          validateLabel={translateModels(t, 'title', 'customer')}
                                        >
                                          <Form.Select
                                            name="title"
                                            onChange={this.handleChange}
                                            options={CUSTOMER_TITLES.map(i => ({ ...i, text: t(i.text, { ns: TRANSLATION_FILES.constants }) }))}
                                            placeholder={`${t('Select Title')}*`}
                                            search
                                            selectOnBlur={false}
                                            value={editingCustomer.title}
                                          />
                                        </AppForm.Validate>
                                      </Grid.Column>
                                    </Grid>
                                  : null
                                }
                                {
                                  isEditing ?
                                    <Divider style={styles.divider} />
                                  : null
                                }
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')}{isEditing && '*'}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <AppForm.Input
                                          autoComplete="off"
                                          name="name"
                                          onChange={this.handleChange}
                                          placeholder={`${t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')}*`}
                                          ref={this.validation.name}
                                          validation={[required, ...vnFullNameRules]}
                                          value={editingCustomer.name}
                                          validateLabel={t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')}
                                        />
                                      : <i>{data.customerDetail.name}</i>
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                {
                                  (isMalaysia && (isEditing ? editingCustomer.identityTypeID : data.identityTypeID) === IDENTITY_TYPE_BRN) && (
                                    <React.Fragment>
                                      <Grid>
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>{t('Foreign Company', { ns: TRANSLATION_FILES.screens })}</b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          <i>{t(data.isForeignCompany ? 'Yes' : 'No')}</i>
                                        </Grid.Column>
                                      </Grid>
                                      <Divider style={styles.divider} />
                                    </React.Fragment>
                                  )
                                }
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')}{isEditing && '*'}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <AppForm.Input
                                          autoComplete="off"
                                          name="preferredName"
                                          onChange={this.handleChange}
                                          placeholder={`${t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')}*`}
                                          ref={this.validation.preferredName}
                                          validation={
                                            editingCustomer.identityTypeID === IDENTITY_TYPE_BRN
                                              ? [required, ...vnPreferredNameValidations(auth, t)]
                                              : [
                                                required,
                                                {
                                                  validate: stringLength,
                                                  option: {
                                                    max: 15,
                                                  },
                                                },
                                                ...vnPreferredNameValidations(auth, t),
                                              ]
                                          }
                                          value={editingCustomer.preferredName}
                                          validateLabel={t(editingCustomer.identityTypeID === IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')}
                                        />
                                      : <i>{data.customerDetail.preferredName}</i>
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'email', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <AppForm.Input
                                          autoComplete="off"
                                          name="email"
                                          onChange={this.handleChange}
                                          placeholder={translateModels(t, 'email', 'customer')}
                                          validation={[email]}
                                          ref={this.validation.email}
                                          value={this.state.editingCustomer.email}
                                          validateLabel={translateModels(t, 'email', 'customer')}
                                        />
                                      : <a href={`mailto:${data.customerDetail.email}`}>{data.customerDetail.email}</a>
                                    }

                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'mobile', 'customer')}{isEditing && '*'}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <Grid className="compact">
                                          <Grid.Column width={16}>
                                            <AppForm.Validate
                                              validation={[required]}
                                              ref={this.validation.mobilePrefix}
                                              onChange={this.handleChange}
                                              validateLabel={translateModels(t, 'mobilePrefix', 'customer')}
                                            >
                                              <Form.Select
                                                name="mobilePrefix"
                                                onChange={this.handleChange}
                                                options={INTL_CALL_CODES}
                                                search
                                                selectOnBlur={false}
                                                value={editingCustomer.mobilePrefix}
                                              />
                                            </AppForm.Validate>
                                          </Grid.Column>
                                          <Grid.Column width={16}>
                                            <PhoneInput
                                              autoComplete="off"
                                              name="mobile"
                                              onChange={this.handleChange}
                                              placeholder={editingCustomer.mobilePrefix === '60' ? `${translateModels(t, 'mobile', 'customer')}* (e.g. 196756118)` : `${translateModels(t, 'mobile', 'customer')}*`}
                                              prefix={editingCustomer.mobilePrefix}
                                              ref={this.validation.mobile}
                                              type="tel"
                                              validation={[required, {
                                                validate: phoneNumber,
                                                option: editingCustomer.mobilePrefix === 'other' ? {} : {
                                                  isMobile: true,
                                                  phonePrefix: editingCustomer.mobilePrefix,
                                                  validRegex: getPhoneValidRegex(
                                                    this.state.phoneValidationPresets,
                                                    editingCustomer.mobilePrefix,
                                                    'mobile',
                                                  ),
                                                },
                                              }]}
                                              value={editingCustomer.mobile}
                                              validateLabel={translateModels(t, 'mobile', 'customer')}
                                            />
                                          </Grid.Column>
                                        </Grid>
                                    : <Phone
                                      mobilePrefix={data.customerDetail.mobilePrefix}
                                      mobile={data.customerDetail.mobile}
                                    />
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{t('House/Office Phone')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <Grid className="compact">
                                          <Grid.Column width={16}>
                                            <Form.Select
                                              name="phonePrefix"
                                              onChange={this.handleChange}
                                              options={INTL_CALL_CODES}
                                              search
                                              selectOnBlur={false}
                                              value={editingCustomer.phonePrefix}
                                            />
                                          </Grid.Column>
                                          <Grid.Column width={16}>
                                            <PhoneInput
                                              autoComplete="off"
                                              name="phone"
                                              onChange={this.handleChange}
                                              placeholder={editingCustomer.phonePrefix === '60' ? `${translateModels(t, 'phone', 'customer')} (e.g. 196756118)` : t('House/Office Phone')}
                                              prefix={editingCustomer.phonePrefix}
                                              ref={this.validation.phone}
                                              type="tel"
                                              value={editingCustomer.phone}
                                              validation={[{
                                                validate: phoneNumber,
                                                option: editingCustomer.phonePrefix === 'other' ? {} : {
                                                  phonePrefix: editingCustomer.phonePrefix,
                                                  validRegex: getPhoneValidRegex(
                                                    this.state.phoneValidationPresets,
                                                    editingCustomer.phonePrefix,
                                                    'phone',
                                                  ),
                                                },
                                              }]}
                                              validateLabel={t('House/Office Phone')}
                                            />
                                          </Grid.Column>
                                        </Grid>
                                    : <Phone
                                      mobilePrefix={data.customerDetail.phonePrefix}
                                      mobile={data.customerDetail.phone}
                                    />
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'jobTitle', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <AppForm.Input
                                          autoComplete="off"
                                          name="jobTitle"
                                          onChange={this.handleChange}
                                          placeholder={translateModels(t, 'jobTitle', 'customer')}
                                          value={editingCustomer.jobTitle}
                                        />
                                      : <i>{data.customerDetail.jobTitle}</i>
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'monthlyIncome', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <AppForm.Input
                                          type="number"
                                          autoComplete="off"
                                          name="monthlyIncome"
                                          onChange={this.handleChange}
                                          placeholder={translateModels(t, 'monthlyIncome', 'customer')}
                                          ref={this.validation.monthlyIncome}
                                          validation={[{
                                            validate: numericRange,
                                            option: {
                                              min: 0,
                                            },
                                          }]}
                                          value={editingCustomer.monthlyIncome}
                                          validateLabel={translateModels(t, 'monthlyIncome', 'customer')}
                                        />
                                      :
                                        <i>
                                          <LoanAmount
                                            format="0,000,000"
                                            amount={data.customerDetail.monthlyIncome}
                                            prefix={<CurrencySymbol />}
                                          />
                                        </i>
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                {
                                  !isEditing &&
                                    <Grid>
                                      <Grid.Column textAlign="left" width={7}>
                                        <b>{this.getIdentityTypeText(data.identityTypeID)}</b>
                                      </Grid.Column>
                                      <Grid.Column textAlign="right" width={9}>
                                        <i>
                                          <Identity
                                            type={data.identityTypeID}
                                            identity={data.identity}
                                          />
                                        </i>
                                      </Grid.Column>
                                    </Grid>
                                }
                                {
                                  !isEditing && <Divider style={styles.divider} />
                                }
                                {
                                  this.hasAccess() &&
                                  <Grid>
                                    <Grid.Column textAlign="left" width={6}>
                                      <b>{translateModels(t, 'internalRemark', 'customer')}</b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={10}>
                                      {
                                        isEditing ? (
                                          <Form.TextArea
                                            name="internalRemark"
                                            value={editingCustomer.internalRemark}
                                            onChange={this.handleChange}
                                          />
                                      ) : <MarkdownText>{data.internalRemark || '-'}</MarkdownText>
                                      }
                                    </Grid.Column>
                                  </Grid>
                                }
                                <Divider style={styles.divider} />
                                { this.hasAccess() ?
                                  <Grid>
                                    <Grid.Column textAlign="left" width={6}>
                                      <b>{translateModels(t, 'maOwnerCompanyBranchShortName', 'customer')}{isEditing && '*'}</b>
                                    </Grid.Column>
                                    {
                                      isEditing ?
                                        <Grid.Column width={10}>
                                          <SearchBranch
                                            onClear={this.handleBranchClear}
                                            onSelect={this.handleBranchSelect}
                                            selectedValue={this.getSelectedBranchValue()}
                                          />
                                        </Grid.Column>
                                      :
                                        <Grid.Column textAlign="right" width={10}>
                                          {data.maOwnerCompanyBranchShortName ?
                                            data.maOwnerCompanyBranchShortName
                                            : '-'
                                          }
                                        </Grid.Column>
                                    }
                                  </Grid>
                                  : ''
                                }
                                {
                                  this.hasAccess() &&
                                    <Divider style={styles.divider} />
                                }
                              </Grid.Column>
                              <Grid.Column mobile={16} tablet={8} computer={8}>
                                {
                                  isEditing && (isMalaysia || isIndonesia) && (
                                    <div>
                                      <Grid>
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>
                                            {isMalaysia && 'Tax Identification Number (TIN)'}
                                            {isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'}
                                          </b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          <TinFieldInput
                                            isIndonesia={isIndonesia}
                                            value={editingCustomer.taxIdentificationNo}
                                            errMessage={this.state.tinMessage}
                                            style={{ width: '100%', marginBottom: '1em' }}
                                            isLoading={this.state.validatingTin}
                                            tinError={isMalaysia && this.state.tinError}
                                            ref={this.validation.taxIdentificationNo}
                                            onChange={this.handleTinInput}
                                            hideLabel
                                            required={!isIndonesia && mustValidTin && !editingCustomer.isForeignCompany}
                                            validation={tinValidation}
                                            // readOnly={this.state.tinFound}
                                            identityType={editingCustomer.identityTypeID}
                                            identityValue={editingCustomer.identity}
                                          />
                                        </Grid.Column>
                                      </Grid>
                                      <Divider style={styles.divider} />
                                    </div>
                                  )
                              }
                                {
                                  _.flatMap(enabledAddressSettings.map((as, idx) => {
                                    const key = _.camelCase(as.columnName);
                                    let addressLabel = as.label.toLowerCase();
                                    let isRequired = as.required;
                                    const validations = [{
                                      validate: stringLength,
                                      option: {
                                        max: 256,
                                      },
                                    }];

                                    // When company is Vietnam: apply country-dependent logic for state field
                                    if (isVietnam && addressLabel === 'state') {
                                      if (isMalaysiaAddress) {
                                        // Malaysia selected: keep as "State", required
                                        isRequired = true;
                                      } else {
                                        // Non-Malaysia selected: change to "City/Province", optional
                                        addressLabel = 'cityOrProvince';
                                        isRequired = false;
                                      }
                                    } else if (isVietnam && addressLabel === 'city' && !isMalaysiaAddress) {
                                      addressLabel = 'ward';
                                      isRequired = false;
                                    } else if (isVietnam && addressLabel === 'postcode' && !isMalaysiaAddress) {
                                      addressLabel = 'postalCode';
                                      isRequired = false;
                                    }

                                    if (isRequired) {
                                      validations.push(required);
                                    }

                                    const label = `${translateModels(this.props.t, addressLabel, 'project')}${isRequired && isEditing ? '*' : ''}`;
                                    return (
                                      <Grid key={idx}>
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>{label}</b>
                                        </Grid.Column>
                                        <Grid.Column textAlign="right" width={10}>
                                          {
                                            isEditing ?
                                              isMalaysiaAddress && as.label.toLowerCase() === 'state' ? (
                                                <AppForm.Validate
                                                  validation={isRequired ? [required] : null}
                                                  ref={this.validation[key]}
                                                  onChange={this.handleChange}
                                                  validateLabel={as.label}
                                                >
                                                  <Form.Select
                                                    name={key}
                                                    fluid
                                                    options={STATES}
                                                    onChange={this.handleChange}
                                                    placeholder={`${t('Select', { ns: TRANSLATION_FILES.translation })} ${label.toLowerCase()}`}
                                                    search
                                                    selectOnBlur={false}
                                                    value={editingCustomer[key]}
                                                  />
                                                </AppForm.Validate>
                                              ) : (
                                                <AppForm.Input
                                                  autoComplete="off"
                                                  name={key}
                                                  onChange={this.handleChange}
                                                  placeholder={label}
                                                  ref={this.validation[key]}
                                                  validation={validations}
                                                  value={editingCustomer[key]}
                                                  validateLabel={as.label}
                                                />
                                              )
                                            : (
                                              <i>
                                                {
                                                  isMalaysiaAddress && as.label.toLowerCase() === 'state' ?
                                                    this.valueToText(STATES, data.customerDetail[key])
                                                  : data.customerDetail[key] ? data.customerDetail[key] : '-'
                                                }
                                              </i>
                                            )
                                          }
                                        </Grid.Column>
                                      </Grid>
                                    );
                                  }), (value, idx) => [value, <Divider key={`divider_${idx}`} style={styles.divider} />])
                                }
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'region', 'project')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <AppForm.Validate
                                          // validation={[required]}
                                          ref={this.validation.region}
                                          onChange={(e, stateData) => {
                                            // Reset state input field
                                            const as = enabledAddressSettings.find(a => a.label.toLowerCase() === 'state');
                                            if (as) {
                                              const key = _.camelCase(as.columnName);
                                              if (editingCustomer[key]) {
                                                editingCustomer[key] = '';
                                                this.setState({ editingCustomer });
                                              }
                                            }
                                            this.handleChange(e, stateData);
                                          }}
                                          validateLabel={translateModels(t, 'region', 'project')}
                                        >
                                          <Form.Select
                                            autoComplete="off"
                                            fluid
                                            name="region"
                                            options={[]}
                                            placeholder={`Select ${translateModels(t, 'region', 'project')}`}
                                            search
                                            selectOnBlur={false}
                                            value={editingCustomer.region}
                                          />
                                        </AppForm.Validate>
                                      : data.customerDetail ? data.customerDetail.region : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'country', 'customer')}{isEditing && '*'}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <AppForm.Validate
                                          validation={[required]}
                                          ref={this.validation.country}
                                          onChange={(e, stateData) => {
                                            // Reset state input field
                                            const as = enabledAddressSettings.find(a => a.label.toLowerCase() === 'state');
                                            if (as) {
                                              const key = _.camelCase(as.columnName);
                                              if (editingCustomer[key]) {
                                                editingCustomer[key] = '';
                                                this.setState({ editingCustomer });
                                              }
                                            }
                                            this.handleChange(e, stateData);
                                          }}
                                          validateLabel={translateModels(t, 'country', 'customer')}
                                        >
                                          <Form.Select
                                            autoComplete="off"
                                            fluid
                                            name="country"
                                            options={SELECT_COUNTRIES}
                                            placeholder={`${t('Select Country')}*`}
                                            search
                                            selectOnBlur={false}
                                            value={editingCustomer.country}
                                          />
                                        </AppForm.Validate>
                                      : getCountryName(
                                          data.customerDetail ? data.customerDetail.country : null,
                                        )
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'nationality', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <Form.Select
                                          name="nationality"
                                          onChange={this.handleChange}
                                          options={SELECT_NATIONALITY}
                                          placeholder={translateModels(t, 'nationality', 'customer')}
                                          search
                                          selectOnBlur={false}
                                          selection
                                          value={editingCustomer.nationality}
                                        />
                                      :
                                        data.customerDetail ?
                                        this.valueToText(
                                          SELECT_NATIONALITY,
                                          data.customerDetail.nationality,
                                        )
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                {
                                  !isEditing && (isMalaysia || isIndonesia) && (
                                    <div>
                                      <Grid>
                                        <Grid.Column textAlign="left" width={6}>
                                          <b>
                                            {isMalaysia && 'Tax Identification Number (TIN)'}
                                            {isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'}
                                          </b>
                                        </Grid.Column>
                                        <Grid.Column
                                          textAlign="right"
                                          width={10}
                                        >
                                          <span style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            {data.taxIdentificationNo ? (
                                              <div>
                                                {isMalaysia && (
                                                  <Icon
                                                    name={data.taxTinValidationStatus === 'success' ? 'check circle' : 'remove circle'}
                                                    color={data.taxTinValidationStatus === 'success' ? 'green' : 'red'}
                                                    style={{ marginLeft: '0.5em' }}
                                                  />
                                                )}
                                                {data.taxIdentificationNo}
                                              </div>
                                            ) : (
                                              '-'
                                            )}
                                          </span>
                                        </Grid.Column>
                                      </Grid>
                                      <Divider style={styles.divider} />
                                    </div>
                                  )
                                }
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'birthdate', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <InputBirthdate
                                          date={editingCustomer.birthdate}
                                          onSelectDay={(day) => {
                                            editingCustomer.birthdate = day;
                                            this.setState({ editingCustomer });
                                          }}
                                        />
                                      :
                                        data.customerDetail ?
                                        data.customerDetail.birthdate
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'gender', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <Form.Select
                                          name="gender"
                                          onChange={this.handleChange}
                                          options={GENDER.map(o => ({
                                            ...o,
                                            text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                                          }))}
                                          placeholder={t('Select Gender')}
                                          search
                                          selectOnBlur={false}
                                          selection
                                          value={editingCustomer.gender}
                                        />
                                      :
                                        data.customerDetail ?
                                        t(
                                          this.valueToText(
                                            GENDER,
                                            data.customerDetail.gender,
                                          ),
                                          { ns: TRANSLATION_FILES.constants },
                                        )
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'maritalStatus', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <Form.Select
                                          name="maritalStatus"
                                          onChange={this.handleChange}
                                          options={MARITAL_STATUS.map(o => ({
                                            ...o,
                                            text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                                          }))}
                                          placeholder={t('Select Marital Status')}
                                          search
                                          selectOnBlur={false}
                                          selection
                                          value={editingCustomer.maritalStatus}
                                        />
                                      :
                                        data.customerDetail ?
                                         t(
                                          this.valueToText(
                                            MARITAL_STATUS,
                                            data.customerDetail.maritalStatus,
                                          ),
                                          { ns: TRANSLATION_FILES.constants },
                                        )
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                {/* <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'race', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <div>
                                          <Form.Select
                                            name="race"
                                            fluid
                                            options={RACE}
                                            onChange={this.handleChange}
                                            placeholder={t('Select Race')}
                                            search
                                            selectOnBlur={false}
                                            value={editingCustomer.race}
                                          />
                                          {
                                            editingCustomer.race.toUpperCase() === 'Others'.toUpperCase() ?
                                              <AppForm.Input
                                                autoComplete="off"
                                                fluid
                                                name="raceOther"
                                                onChange={this.handleChange}
                                                placeholder={t('Fill in your Race')}
                                                value={editingCustomer.raceOther}
                                                validateLabel={translateModels(t, 'raceOther', 'customer')}
                                                ref={this.validation.raceOther}
                                                validation={editingCustomer.race.toUpperCase() === 'Others'.toUpperCase() ? [required] : null}
                                              />
                                            : ''
                                          }

                                        </div>
                                      :
                                        data.customerDetail ?
                                        data.customerDetail.race
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid> */}
                                {/* <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'bumi', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ?
                                        <Form.Select
                                          name="bumi"
                                          fluid
                                          options={BUMI.map(o => ({
                                            ...o,
                                            text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                                          }))}
                                          onChange={this.handleChange}
                                          placeholder={t('Select Bumiputera Status')}
                                          search
                                          selectOnBlur={false}
                                          value={editingCustomer.bumi}
                                        />
                                      :
                                        data.customerDetail ?
                                        data.customerDetail.bumi
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid> */}
                                <Divider style={styles.divider} />
                              </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                              <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'emergencyContactName', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ? (
                                        <AppForm.Input
                                          autoComplete="off"
                                          name="emergencyContactName"
                                          onChange={this.handleChange}
                                          placeholder={translateModels(t, 'emergencyContactName', 'customer')}
                                          value={editingCustomer.emergencyContactName}
                                        />
                                      ) :
                                        data.customerDetail ?
                                        data.customerDetail.emergencyContactName
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'emergencyContactRelation', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ? (
                                        <AppForm.Input
                                          autoComplete="off"
                                          name="emergencyContactRelation"
                                          onChange={this.handleChange}
                                          placeholder={translateModels(t, 'emergencyContactRelation', 'customer')}
                                          value={editingCustomer.emergencyContactRelation}
                                        />
                                      ) :
                                        data.customerDetail ?
                                        data.customerDetail.emergencyContactRelation
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'emergencyContactMobile', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ? (
                                        <div>
                                          <AppForm.Validate
                                            ref={this.validation.emergencyContactMobilePrefix}
                                            onChange={this.handleChange}
                                            validateLabel={translateModels(t, 'emergencyContactMobilePrefix', 'customer')}
                                          >
                                            <Form.Select
                                              name="emergencyContactMobilePrefix"
                                              onChange={this.handleChange}
                                              options={INTL_CALL_CODES}
                                              search
                                              selectOnBlur={false}
                                              value={editingCustomer.emergencyContactMobilePrefix}
                                            />
                                          </AppForm.Validate>
                                          <PhoneInput
                                            autoComplete="off"
                                            name="emergencyContactMobile"
                                            onChange={this.handleChange}
                                            placeholder={translateModels(t, 'emergencyContactMobile', 'customer')}
                                            prefix={editingCustomer.emergencyContactMobilePrefix}
                                            ref={this.validation.emergencyContactMobile}
                                            type="tel"
                                            validation={[{
                                              validate: phoneNumber,
                                              option: editingCustomer.emergencyContactMobilePrefix === 'other' ? {} : {
                                                isMobile: true,
                                                phonePrefix: editingCustomer.emergencyContactMobilePrefix,
                                                validRegex: getPhoneValidRegex(
                                                  this.state.phoneValidationPresets,
                                                  editingCustomer.emergencyContactMobilePrefix,
                                                  'mobile',
                                                ),
                                              },
                                            }]}
                                            value={editingCustomer.emergencyContactMobile}
                                            validateLabel={translateModels(t, 'emergencyContactMobile', 'customer')}
                                          />
                                        </div>
                                      ) :
                                        data.customerDetail ?
                                          <Phone
                                            mobilePrefix={data.customerDetail.emergencyContactMobilePrefix}
                                            mobile={data.customerDetail.emergencyContactMobile}
                                          />
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} className="large-hide small-hide tablet-hide" />
                              </Grid.Column>
                              <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'emergencyContactEmail', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ? (
                                        <AppForm.Input
                                          autoComplete="off"
                                          name="emergencyContactEmail"
                                          type="email"
                                          onChange={this.handleChange}
                                          placeholder={translateModels(t, 'emergencyContactEmail', 'customer')}
                                          validation={[email]}
                                          ref={this.validation.emergencyContactEmail}
                                          value={editingCustomer.emergencyContactEmail}
                                        />
                                      ) :
                                        data.customerDetail ?
                                        data.customerDetail.emergencyContactEmail
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} />
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'emergencyContactIdentity', 'customer')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      isEditing ? (
                                        <AppForm.Input
                                          autoComplete="off"
                                          name="emergencyContactIdentity"
                                          onChange={this.handleChange}
                                          placeholder={translateModels(t, 'emergencyContactIdentity', 'customer')}
                                          value={editingCustomer.emergencyContactIdentity}
                                        />
                                      ) :
                                        data.customerDetail ?
                                        data.customerDetail.emergencyContactIdentity
                                        : '-'
                                    }
                                  </Grid.Column>
                                </Grid>
                                <Divider style={styles.divider} className="large-hide small-hide tablet-hide" />
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </AppForm>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}
              />
            </Grid.Column>
          </Grid.Row>
          {
            data.identityTypeID === 1 &&
            this.props.auth.creditCheckAccess && (
              <Grid.Row>
                <Grid.Column width={16}>
                  <Segment className="dark credit-check" color="grey" inverted secondary textAlign="center">
                    <Divider horizontal inverted>Credit Check</Divider>
                    {
                      data.customerCreditReportID ?
                        <CreditCheckScores
                          {...data.customerCreditReport}
                          editClick={() => {
                            store.dispatch(push(`/customers/${data.id}/income/${data.income.id}/`));
                          }}
                          auth={this.props.auth}
                          allowBranchLeaderDownload={companyApp ? companyApp.allowBranchLeaderDownload : false}
                          allowAgentDownload={companyApp ? companyApp.allowAgentDownload : false}
                          allowStaffDownload={companyApp ? companyApp.allowStaffDownload : false}
                          openHTML={this.handleOpenHTML}
                          netIncome={data.income && data.income.netIncome}
                        /> : null
                    }
                    <Segment color="black" inverted secondary style={{ marginTop: '2em' }}>
                      <Header
                        as="h3"
                        style={{ margin: '1.5em 0' }}
                      >
                        Help purchasers know their loan eligibility in 4 easy steps
                        <Header.Subheader style={{ marginTop: '0.25em' }}>Advice purchasers based on their credit score</Header.Subheader>
                      </Header>
                      <CreditCheckSplash
                        actionNode={
                          <Grid.Row textAlign="center">
                            <Grid.Column
                              mobile={16}
                              tablet={6}
                              computer={data.customerCreditReportID ? 5 : 4}
                            >
                              <Button
                                as={Link}
                                fluid
                                positive
                                disabled={this.state.loading}
                                onClick={this.handleCheckAvailableCredits}
                              >
                                <i className="icon">
                                  <img src="/assets/images/icons/credit_check_small.svg" alt="" />
                                </i>
                                {data.customerCreditReportID ? 'Generate New Credit Check' : 'Run Credit Check'}
                              </Button>
                            </Grid.Column>
                            {/* {
                              data.customerCreditReportID ? (
                                <Grid.Column
                                  mobile={16}
                                  tablet={6}
                                  computer={5}
                                >
                                  <Button
                                    as={Link}
                                    fluid
                                    primary
                                    content="View Previous Credit Checks"
                                    to={`/customers/${data.id}/credit_check/#records`}
                                    disabled={this.state.loading}
                                  />
                                </Grid.Column>
                              ) : null
                            } */}
                          </Grid.Row>
                        }
                      />
                    </Segment>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            )
          }
          {
            (isPRS && data.identityTypeID === 1) ?
              <Grid.Row style={{ paddingTop: '0' }}>
                <Grid.Column mobile={16}>
                  <Divider style={{ margin: '0.5em 0' }} />
                  <LPPSAChecker
                    data={data}
                    token={this.props.token}
                    type="customer"
                    loading={this.state.loading}
                    onChange={this.handleOnChangeLPPSA}
                  />
                </Grid.Column>
              </Grid.Row>
              : ''
          }
          { this.hasAccess() &&
            <Grid.Row>
              <Grid.Column>
                <Divider horizontal>{t('Customer Bookings')}</Divider>
                <CustomerBookings
                  params={this.props.params}
                  location={this.props.location}
                />
              </Grid.Column>
            </Grid.Row>
          }
        </Grid>
      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.customer,
  TRANSLATION_FILES.models.project,
])(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/Customers/Overview.jsx